import * as yup from 'yup';
import { ClientPriceDTO } from 'model';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { ArrowForward } from '@material-ui/icons';
import { buildDTOView } from '../../../../transformer/DTOViewSchema';
import { FormikEntitySelect } from '../../../../components/select/FormikEntitySelect';
import { priceUnitsAPI } from '../../../prices/redux/price-units.slice';
import { serviceClassAPI } from '../../../services/redux/service-classes.slice';
import { supplierPriceView } from '../../../suppliers/components/prices/SupplierPriceForm';
import { FormikLanguageSelect } from '../../../../components/select/FormikLanguageSelect';
import { FormikTextField } from '../../../../components/input/FormikTextField';
import { FormikCurrencySelect } from '../../../../components/select/FormikCurrencySelect';
import { FormikPriceInput } from './FormikPriceInput';

const validationSchema: yup.SchemaOf<ClientPriceDTO> = yup.object({
  priceUnitId: yup.string().required(),
  serviceClassId: yup.string().default(null).nullable(),
  sourceLanguageId: yup.string().default(null).nullable(),
  targetLanguageId: yup.string().default(null).nullable(),
  customConstraint: yup.string().max(512).default(null).nullable(),
  description: yup.string().max(512).default(null).nullable(),
  price: yup
    .object()
    .required()
    .shape({
      expressPrice: yup.number().default(null).nullable(),
      price: yup.number().required(),
      currency: yup.string().default(null).nullable()
    })
});

export const clientPriceView = buildDTOView<ClientPriceDTO>()
  .all()
  .withSchema(validationSchema);

export function ClientPriceForm() {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <FormikEntitySelect
          textFieldProps={{ label: t('Unit') }}
          entityApi={priceUnitsAPI}
          optionLabel={(value) => value.name}
          name={clientPriceView.path.priceUnitId}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <FormikPriceInput
          amountPath={supplierPriceView.path.price.price}
          label={t('Price')}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <FormikPriceInput
          amountPath={supplierPriceView.path.price.expressPrice}
          label={t('ExpressPrice')}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4}>
        <FormikCurrencySelect
          textFieldProps={{ label: t('Currency') }}
          name={supplierPriceView.path.price.currency}
          nullable
          withoutToggle
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <FormikTextField
          label={t('Description')}
          name={supplierPriceView.path.description}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Divider style={{ marginTop: 20, marginBottom: 20 }} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Typography variant="body2" color="textSecondary">
          {t('Conditions (optional)')}:
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <FormikEntitySelect
          textFieldProps={{ label: t('Service Class') }}
          entityApi={serviceClassAPI}
          optionLabel={(value) => value.name}
          name={supplierPriceView.path.serviceClassId}
        />
      </Grid>
      <Grid item xs={12} container spacing={1}>
        <Grid item xs={12} sm={5} md={5} lg={5}>
          <FormikLanguageSelect
            name={supplierPriceView.path.sourceLanguageId}
            label={t('Source Language')}
          />
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center'
          }}
        >
          <ArrowForward />
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={5}>
          <FormikLanguageSelect
            name={supplierPriceView.path.targetLanguageId}
            label={t('Target Language')}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormikTextField
            label={t('Custom Constraint')}
            name={supplierPriceView.path.customConstraint}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
